import {Component, Inject, OnInit} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FormValidators} from '@app/core/utils/form.validators';

@Component({
    selector: 'ngc-datetime-range-dialog',
    templateUrl: './datetime-range-dialog.component.html',
    styleUrls: ['./datetime-range-dialog.component.css']
})
export class DatetimeRangeDialogComponent implements OnInit {

    formGroup: UntypedFormGroup;

    constructor(
        public dialogRef: MatDialogRef<DatetimeRangeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public injectedData: {
            startDate: Date;
            endDate: Date;
            minDate: Date;
            maxDate: Date;
        }
    ) {
        if (this.injectedData.minDate) {
            this.injectedData.minDate = new Date(
                this.injectedData.minDate.getFullYear(),
                this.injectedData.minDate.getMonth(),
                this.injectedData.minDate.getDate(),
                this.injectedData.minDate.getHours(),
                this.injectedData.minDate.getMinutes(),
                0,
                0
            );
        }

        const tzOffset = (new Date()).getTimezoneOffset() * 60000;
        const startDate = this.injectedData.startDate || this.injectedData.minDate;
        const endDate = this.injectedData.endDate || this.injectedData.maxDate;

        const startDateStr = startDate ? (new Date(startDate.getTime() - tzOffset)).toISOString().slice(0, 16) : '';
        const endDateStr = endDate ? (new Date(endDate.getTime() - tzOffset)).toISOString().slice(0, 16) : '';
        const startDateCtrl = new UntypedFormControl(startDateStr);
        const endDateCtrl = new UntypedFormControl(endDateStr);
        startDateCtrl.setValidators([
            Validators.required,
            FormValidators.dateRange(this.injectedData.minDate, this.injectedData.maxDate, null, endDateCtrl)
        ]);
        endDateCtrl.setValidators([
            Validators.required,
            FormValidators.dateRange(this.injectedData.minDate, this.injectedData.maxDate, startDateCtrl)
        ]);
        this.formGroup = new UntypedFormGroup({
            startDate: startDateCtrl,
            endDate: endDateCtrl
        });
    }

    ngOnInit(): void {
    }

    changeStartDate() {
        this.updateControlValidity('endDate');
    }

    changeEndDate() {
        this.updateControlValidity('startDate');
    }

    onSave() {
        this.dialogRef.close({
            startDate: new Date(this.formGroup.controls['startDate'].value),
            endDate: new Date(this.formGroup.controls['endDate'].value)
        });
    }

    onClose() {
        this.dialogRef.close();
    }

    private updateControlValidity(controlName: string) {
        this.formGroup.controls[controlName].updateValueAndValidity();
    }
}
